import {Button, Col, Row, Space} from "antd";
import React, {useMemo, useState} from "react";
import {useTranslate} from "../../../../hooks/translate.hook";
import { ComponentPropsFromRoute } from "../../../../routers/routers";
import {SmartTable} from "../../../common/smart-table/smart-table";
import {SmartTableDataHandler} from "../../../common/smart-table/smart-table.data-handler";
import {columnsFactory} from "./agent.data.pickup-authorizations.columns";
import {
    accountPickupAuthorizationsService
} from "../../../../services/accounts/account.pickup-authorizations.service";
import {useRequiredStore} from "../../../../utils/store";
import {AgentDataStoreContext} from "../agent.data.store";
import {
    PickupAuthorization
} from "../../../../models/accounts/customer-account/wholesale-account/wholesale.account.pickup-authorizations";
import {AgentDataPickupAuthorizationCreateModal} from "./modal/edit/agent.data.pickup-authorization.create.modal";
import {notifications} from "../../../../services/notifications/notifications";

interface AgentDataPickupAuthorizationsProps extends ComponentPropsFromRoute {}

export const AgentDataPickupAuthorizations: React.FC<AgentDataPickupAuthorizationsProps> = ({ name }) => {
    const t = useTranslate();
    const {account} = useRequiredStore(AgentDataStoreContext);

    const columns = useMemo(() => columnsFactory(t), [t]);
    const handler = useMemo(()=>
        new SmartTableDataHandler(request => accountPickupAuthorizationsService.getPaginated(request, account!.id)), []);

    const [editModalShown, setEditModalShown] = useState<boolean>(false);
    const [editModalItem, setEditModalItem] = useState<PickupAuthorization | null>(null);

    const onClose = () => {
        setEditModalShown(false)
        setEditModalItem(null)
    }

    const create = () => {
        setEditModalShown(true)
        setEditModalItem(null)
    }

    const edit = (item: PickupAuthorization) => {
        setEditModalShown(true)
        setEditModalItem(item)
    }

    const remove = async (item: PickupAuthorization) => {
        await accountPickupAuthorizationsService.remove(item.id)
        await handler.reloadItemsWithLastRequest()
        notifications.successfully();
    }

    const setDefault = async (item: PickupAuthorization) => {
        await accountPickupAuthorizationsService.setDefault(item.id)
        await handler.reloadItemsWithLastRequest()
        notifications.successfully();
    }

    return (
        <Space direction={"vertical"}>
            <Button type="primary" onClick={() => create()}>
                {t("ADD")}
            </Button>
            <Row>
                <Col span={16}>
                    <SmartTable
                        columns={columns}
                        handler={handler}
                        actions={[
                            {
                                icon: 'arrow-up',
                                title: 'Set default',
                                onClick: (item) => setDefault(item)
                            },
                            {
                                icon: 'edit',
                                title: 'Edit',
                                onClick: (item) => edit(item)
                            },
                            {
                                icon: 'remove',
                                title: 'Remove',
                                onClick: (item) => remove(item)
                            }
                        ]}
                    />
                </Col>
            </Row>
            {editModalShown ? (
                <AgentDataPickupAuthorizationCreateModal
                    item={editModalItem}
                    accountId={account!.id}
                    onClose={() => onClose()}
                    onComplete={() => handler.reloadItemsWithLastRequest()}
                    />
            ) : null}
        </Space>
    );
}